import { Button } from '@/components';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAnalysisPageSearchQueryStates } from '../../_hooks/search-query-states';
import {
  getAnalysisSearchHistory,
  removeAnalysisSearchHistory,
  setAnalysisSearchHistory,
} from '../../_utils/analysis-session-storage';

type Props = {
  disabled: boolean;
};

export const FilterHistoryBackButton = ({ disabled }: Props) => {
  const { t } = useTranslation();
  const { searchQueryStates, setSearchQueryStates } =
    useAnalysisPageSearchQueryStates();

  useEffect(() => {
    if (disabled) {
      removeAnalysisSearchHistory();
      setAnalysisSearchHistory([searchQueryStates]);
    } else {
      const history = getAnalysisSearchHistory();

      const lastState = history.at(-1);
      const isNewState =
        !lastState ||
        JSON.stringify(lastState) !== JSON.stringify(searchQueryStates);
      if (isNewState) {
        setAnalysisSearchHistory([...history, searchQueryStates]);
      }
    }
  }, [searchQueryStates, disabled]);

  const applyAndPopFilter = useCallback(() => {
    const history = getAnalysisSearchHistory();
    const lastSearchQueryStates = history.at(-2);
    datadogRum.addAction('履歴を戻るボタンが使用されました。');
    if (lastSearchQueryStates) {
      setSearchQueryStates(lastSearchQueryStates);
      setAnalysisSearchHistory(history.slice(0, -1));
      return;
    }

    const lastHistory = history.at(0);
    if (lastHistory) {
      setSearchQueryStates(lastHistory);
    }
  }, [setSearchQueryStates]);

  return (
    <Button onClick={applyAndPopFilter} disabled={disabled}>
      {t('filter-history-back')}
    </Button>
  );
};
